//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import PublicChats from '~/views/UserChats/PublicChats.vue';
import PrivateChats from '~/views/UserChats/PrivateChats.vue';

export default {
  components: {
    PublicChats,
    PrivateChats,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.getPublicChats(),
      this.getPrivateChats(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('userPublicChats', ['getPublicChats']),
    ...mapActions('userPrivateChats', ['getPrivateChats']),
  },
};
